import React from 'react';
import { Route, Switch, SwitchProps, match } from 'react-router-dom';
import { FreeLeadGeneratorLanding } from './FreeLeadGeneratorLanding/FreeLeadGeneratorLanding';
import { AutomatedResponseBuilder } from './FreeLeadGeneratorBuilder/FreeLeadGeneratorBuilder';
import { FreeLeadGeneratorCongratulations } from './FreeLeadGeneratorCongratulations/FreeLeadGeneratorCongratulations';

export const AutomatedResponseSwitch = ({
  match,
}: SwitchProps & { match: match }) => {
  return (
    <Switch>
      <Route
        path={`${match.path}/start`}
        component={AutomatedResponseBuilder}
      />
      <Route
        path={`${match.path}/congratulations`}
        render={() => (
          <FreeLeadGeneratorCongratulations category="automated_response_tool" />
        )}
      />
      <Route path="/" component={FreeLeadGeneratorLanding} />
    </Switch>
  );
};
